import { TextField as MuiTextField } from '@mui/material';
import { lockedTextFieldSx } from '@/components/atoms/TextField/lockedSx';
import { PTextFieldProps } from '@/components/atoms/TextField/types';
import { mergeSx } from '@/utils/cssStyles';

/**
 * `PTextField` is the design system atom for single-line text input.
 *
 * Wraps MUI's `TextField` and adds a third `state`: alongside `enabled`/`disabled`, `locked`
 * renders a readable filled treatment (instead of MUI's dimmed disabled look) for fields that
 * hold a real value the user needs to read but can't edit right now.
 */
export const PTextField = ({ state = 'enabled', sx, ...other }: PTextFieldProps) => {
  return (
    <MuiTextField
      disabled={state !== 'enabled'}
      sx={mergeSx(state === 'locked' ? lockedTextFieldSx : undefined, sx)}
      {...other}
    />
  );
};
